import { useEffect, Fragment } from 'react';
import bem from '../../../utils/bem';
import FooterText from '../../Molecules/FooterText';
import FooterColumn from '../../Molecules/FooterColumn';

const Footer = ({ sections = {}, analytic }) => {
  const baseClass = 'sgna-footer';

  useEffect(() => {
    if (typeof Drupal.behaviors.footer !== 'undefined') {
      Drupal.behaviors.footer.attach(document); // Ensure logic applied for laze component.
    }
  }, []);

  const renderFiveColumnSection = (section) => {
    const { first, second, third, fourth, fifth } = section.components || {};

    const logoWithSocial = () => {
      if (
        !first ||
        !first[0].field_body.length ||
        !first[0].field_body[0].value
      ) {
        return '';
      }

      return (
        <FooterText
          text={first[0].field_body[0].value}
          textClasses="sgna-footer-logo"
          analyticData={analytic && analytic?.navClicked}
        />
      );
    };

    const menus = [second, third, fourth].map((column, index) => {
      if (column) {
        return (
          <div
            key={`footer-menu-column-${index}`}
            className="flex flex-col items-start"
          >
            <FooterColumn column={column} analyticData={analytic} />
          </div>
        );
      }
      return '';
    });

    const newsLetter = () => {
      if (!fifth) {
        return '';
      }

      return (
        <div className="sgna-footer-newsletter">
          <FooterColumn
            column={fifth}
            ctaClasses={bem('link', ['black', 'arrow', 's'])}
            analyticData={analytic}
          />
        </div>
      );
    };

    return (
      <div className={bem('top-content', [], baseClass)}>
        {/* Logo with social */}
        {logoWithSocial()}

        <div className="xl-flex">
          {/* Menus */}
          <div className={bem('menus', [], baseClass)}>{menus}</div>
          {/* Newsletter */}
          {newsLetter()}
        </div>
      </div>
    );
  };

  const renderTopSections = () => {
    return Object.values(sections).map((section, index) => {
      if (
        section.behavior_settings[0].value.layout_paragraphs.layout ===
        'layout_fivecol_section'
      ) {
        return (
          <Fragment key={'sgna-footer-five-col-section'}>
            {renderFiveColumnSection(section)}
          </Fragment>
        );
      }

      return (
        <Fragment key={section.id[0].value}>
          {Object.keys(sections).length - 1 === index || !section.components ? (
            ''
          ) : (
            <div className={bem('section', [], baseClass)}>
              <FooterColumn
                column={section.components.content}
                analyticData={analytic}
              />
            </div>
          )}
        </Fragment>
      );
    });
  };

  const copyrightBlock = () => {
    const sectionsArray = Object.values(sections);
    if (
      sectionsArray.length > 1 &&
      sectionsArray[sectionsArray.length - 1].behavior_settings[0].value
        .layout_paragraphs.layout === 'layout_onecol'
    ) {
      return sectionsArray[sectionsArray.length - 1];
    }

    return false;
  };

  return (
    <div className={bem('blue-dark-gradient', [], baseClass, [])}>
      <div className={bem('top', [], baseClass, ['container'])}>
        {renderTopSections()}
      </div>

      {/* Copyright */}
      {copyrightBlock() && copyrightBlock().components ? (
        <div className={bem('bottom', [], baseClass, [])}>
          <div className="container">
            <FooterColumn
              column={copyrightBlock().components.content}
              analyticData={analytic}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default Footer;
